import { useState } from "react";
import { CalendarDetailList } from "@etframework/ui.components";

export const CalendarDropDown = ({
  id,
  detailList,
  title,
  taskCount,
  emptyMessage,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="et-calendar-drop-down m-2">
      <h6
        className="d-flex justify-content-between align-items-center my-2"
        onClick={toggleDropdown}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex align-items-center gap-2">
          <div className="calendar-drop-down-taskCount">{taskCount}</div>
          <div className="calendar-drop-down-title">{title}</div>
        </div>
        <div className="calendar-drop-down-icon">
          <i className={`fa-solid fa-chevron-${isOpen ? "up" : "down"}`}></i>
        </div>
      </h6>
      {isOpen && (
        <div className="calendar-detail-list-wrapper">
          {detailList && detailList.length > 0 ? (
            <CalendarDetailList id={id} detailList={detailList} />
          ) : (
            <p className="task-empty fs-14 ps-2">{emptyMessage}</p>
          )}
        </div>
      )}
      <hr />
    </div>
  );
};
